import {
  Button,
  CircularProgress,
  Paper,
  Switch,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AutoSearch from "../../../../components/inputs/autoSearch";
import Dropdown from "../../../../components/inputs/dropDown";
import TextInput from "../../../../components/inputs/textInput";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";

const ProductForm = ({ data, setData, handleSumbit, loadingSubmit }) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { id } = useParams();
  const [error, setError] = useState({});
  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const [inputValue, setInputValue] = React.useState("");

  const [measurement, setMeasurement] = useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  useEffect(() => {
    axiosInstance
      .get(API.public.measurement, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setMeasurement(res?.data?.data);
      })
      .catch((err) => {});
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <Paper
        /*    sx={{}} */

        elevation={1}
        className="mx-3 my-5 border py-3 px-3 relative z-40"
      >
        <Tabs
          sx={{
            flexGrow: 1,
            height: "3.07rem",
            minHeight: "3.07rem !important",
            ".MuiTab-root": {
              minHeight: "3.07rem !important",
            },

            ".MuiTabs-flexContainer": {
              justifyContent: { xs: "center", md: "start" },
            },
          }}
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          className="primary"
        >
          <Tab label=" اطلاعات پایه  " {...a11yProps(0)} />
          <Tab className="middle" label=" اطلاعات تکمیلی " {...a11yProps(1)} />
        </Tabs>

        <TabPanel dir={"rtl"} value={value} index={0}>
          <div className="flex flex-col mt-7 gap-4 ">
            {!id ? (
              <div className="lg:col-span-3">
                <AutoSearch
                  label="کالا/خدمت مالیاتی"
                  onChange={(e) => {
                    setData({ ...data, guidStuffRecNo: e });
                    if (!e) {
                      setError({ ...error, guidStuffRecNo: true });
                    } else {
                      setError({ ...error, guidStuffRecNo: false });
                    }
                  }}
                  value={data?.guidStuffRecNo ? data?.guidStuffRecNo : ""}
                  err={error.guidStuffRecNo}
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                />
              </div>
            ) : (
              <>
                {" "}
                <TextInput
                  label="کالا/خدمت مالیاتی"
                  InputProps={{ readOnly: true }}
                  value={data?.chName || ""}
                />
              </>
            )}{" "}
            <TextInput
              label=" عنوان جایگزین"
              onChange={(e) => {
                setData({ ...data, chTitle: e });
                if (!e) {
                  setError({ ...error, chTitle: true });
                } else {
                  setError({ ...error, chTitle: false });
                }
              }}
              value={data?.chTitle || ""}
              err={error.chTitle}
            />
            <TextInput
              label=" شناسه"
              onChange={(e) => {
                setData({ ...data, chSaleSoftID: e });
                if (!e) {
                  setError({ ...error, chSaleSoftID: true });
                } else {
                  setError({ ...error, chSaleSoftID: false });
                }
              }}
              value={data?.chSaleSoftID || ""}
              err={error.chSaleSoftID}
            />
            <Dropdown
              label="واحد اندازه گیری"
              onChange={(e) => {
                setData({ ...data, guidMeasurementUnitRecNo: e });
                if (!e) {
                  setError({ ...error, guidMeasurementUnitRecNo: true });
                } else {
                  setError({ ...error, guidMeasurementUnitRecNo: false });
                }
              }}
              value={data?.guidMeasurementUnitRecNo}
              data={measurement}
              err={error.guidMeasurementUnitRecNo}
            />
          </div>
        </TabPanel>
        <TabPanel dir={"rtl"} value={value} index={1}>
          <div className="flex flex-col gap-4 mt-7 ">
            <TextInput
              label="مبلغ واحد"
              onChange={(e) => setData({ ...data, moUnitPrice: Number(e) })}
              value={data?.moUnitPrice ? String(data?.moUnitPrice) : ""}
              number
              price
            />
            <TextInput
              label="توضیحات"
              onChange={(e) => setData({ ...data, chComment: e })}
              value={data?.chComment || ""}
              rows={2}
            />
            <div className="flex gap-3 items-center">
              <span>غیر فعال :‌</span>
              <Switch
                onChange={(e) =>
                  setData({ ...data, btDisabled: !data?.btDisabled })
                }
                checked={data?.btDisabled}
              />
            </div>
            <TextInput
              label="توضیحات غیرفعال"
              onChange={(e) => setData({ ...data, chDisabledComment: e })}
              value={data?.chDisabledComment || ""}
              rows={2}
            />
          </div>
        </TabPanel>
        <div className="flex w-full loginButton my-7 items-center justify-between">
          <Button
            sx={{ width: "135px" }}
            onClick={handleSumbit}
            variant="contained"
            disabled={
              loadingSubmit ||
              !data?.chSaleSoftID ||
              !data?.guidStuffRecNo ||
              !data?.guidMeasurementUnitRecNo
            }
          >
            {loadingSubmit ? (
              <>
                {" "}
                <CircularProgress size={20} />
              </>
            ) : (
              <>ثبت</>
            )}
          </Button>{" "}
          <Button
            sx={{ width: "135px" }}
            onClick={() => navigate("/sell/products")}
            variant="outlined"
          >
            بازگشت
          </Button>
        </div>
      </Paper>
    </>
  );
};

export default ProductForm;
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <>{children}</>
        </>
      )}
    </div>
  );
}
